import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidationErrors, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Location } from '@angular/common'

import { merge, fromEvent, Observable, forkJoin, from, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GlPreviewModalComponent, GlPreviewModalData } from '../../shared/gl-preview-modal/gl-preview-modal.component';
import { GlPreviewLine } from '../../models/gl-preview.model';
import { debounceTime, distinctUntilChanged, map, startWith, tap, delay, switchMap, catchError } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GeneralLedgerService  } from '../../services/general-ledger.service';
import { GlobalsService } from '../../services/globals.service';
import { PrintService } from '../../services/print.service';
import { PaymentsService } from '../../services/payments.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

declare let $: any;

@Component({
	selector: 'app-journal-entry',
	templateUrl: './journal-entry.component.html',
	styleUrls: ['./journal-entry.component.scss']
})
export class JournalEntryComponent implements OnInit {

	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('locationsearch') customersearch: ElementRef;
	@ViewChild('editAddAccount') editAddRef: ElementRef;
	@ViewChild('print_table') printtable: ElementRef;
	/** The import UI lives in a template so it can be opened as a full-size dialog. */
	@ViewChild('glImportDialog') glImportDialogTpl: TemplateRef<any>;
	loccode: any = '';
	addedgl: any = false;
	locselected = false;
	sending = false;
	ld: any = [];
	term: any = '';

	taxgroup: any = '';
	taxes: any = [];
	currencies: any = [];
	bankaccounts: any = [];
	types: any = [];
	zones: any = [];
	accountForm: any = false;
	groups: any = [];
	pandl: any = [];
	accounts: any = [];
	results: any = [];
	glaccounts: any = [];
	allglaccounts: any = [];
	color = 'blue'
	filteredOptions: Observable<any[]>;
	debits_credits: any = [];
	now = new Date();
	resetjournal = false;
	tags: any[] = [];
	editingIndex: number | null = null;
	/** Transaction Date held while a line is being edited under its own date. */
	private headerDateBeforeEdit: any = null;
	preselectedAccount: any = null;
	journal_types = [
		'normal', 'reversing'
	];
	reversalJournalNumber: string | null = null;
	expenseSectionId: string | null = null;

	glUploadFiles: File[] = [];
	glUploadedHeaders: string[] = [];
	glUploadedRawData: any[] = [];
	glColumnMappings: { [header: string]: string } = {};
	glUploadReady = false;
	glDropzoneActive = false;
	glError = '';
	/**
	 * `debitcredit` is one signed column; `debit`/`credit` are the two-column form
	 * every payroll and most accounting-package exports use. Both are offered in
	 * either mode — a file has one shape or the other, not a mode.
	 */
	glAvailableFieldTypes: string[] = ['trandate', 'account', 'description', 'debitcredit', 'debit', 'credit', 'department', 'location', 'ignore'];
	glClosedThroughDate: string | null = null;
	glDepartmentRequired = true;
	glUploadInvalidAccounts: { row: number; code: string }[] = [];
	glUploadInvalidDates: { row: number; value: string }[] = [];
	glUploadClosedPeriodHits: { row: number; date: string }[] = [];

	/** Derived once per change to the upload — never from the template. See recomputeGlUploadDerived(). */
	private glUploadBuilt: any[] = [];
	glUploadTotals = { debit: 0, credit: 0, difference: 0, lines: 0 };

	/**
	 * The raw grid is collapsed by default. It is a correction tool, not the point
	 * of the screen, and rendering thousands of rows of live inputs is the single
	 * most expensive thing here — so it renders only when asked for.
	 */
	glRawDataExpanded = false;
	/** Parsing a large workbook blocks for seconds — say so rather than look dead. */
	glParsing = false;
	/** Set once the operator overrides a column, so re-inference never clobbers their work. */
	glMappingUserEdited = false;
	/** Rows rendered while collapsed-but-peeking, so a huge file cannot lock the tab. */
	readonly glRawPreviewLimit = 50;
	glRawShowAll = false;

	/* ---------- Payroll mode ---------- */

	/**
	 * Payroll files carry the PROVIDER's account codes, not ours, so they need a
	 * translation step the generic dropper has no business doing. Standard mode is
	 * untouched by everything below.
	 */
	glImportMode: 'standard' | 'payroll' = 'standard';
	payrollProfile: any = null;
	payrollProfileName = '';
	payrollFeedHint = '';
	/** key `${code}${desc}` → { erpAccount, accountName, isCash, matchHint, via } */
	payrollResolved: { [key: string]: any } = {};
	payrollUnmapped: { sourceCode: string; sourceDesc: string; pick: string }[] = [];
	payrollDuplicate: any = null;
	payrollDuplicateOverridden = false;
	payrollBankAccounts: any[] = [];
	/**
	 * From inspect: whether the bank feed can actually close cash lines.
	 * null until the first inspect answers — don't flash a warning before we know.
	 */
	payrollFeedStatus: {
		connected: boolean;
		mappedAccounts: string[];
		feedAccounts: string[];
		readyAccounts: string[];
	} | null = null;
	payrollBusy = false;
	payrollNotice = '';
	glFileSha256 = '';
	glFileFormat = '';

	/** Cash lines of the journal just posted, with their bank-feed candidates. */
	payrollPostedTransno: number | null = null;
	payrollCashLines: any[] = [];
	payrollBankLines: any[] = [];
	payrollBankBusy = false;
	payrollBankNotice = '';
	/** Drop metadata captured at import time; consumed once the journal posts. */
	payrollPendingDrop: any = null;

	/* ---------- batched posting ---------- */

	/**
	 * Lines per request. A payroll or upload file can run to thousands of lines,
	 * and journalentry() inserts them one at a time — one request for the lot is
	 * how you get a proxy timeout with a half-written journal behind it.
	 */
	readonly postBatchSize = 200;
	posting = false;
	/**
	 * "This journal moves no money" — set for a RECLASS, where a line lands on a bank
	 * account to correct the books without a penny leaving either bank (e.g. moving a
	 * mis-keyed receipt from 1000-30 to 1000-29). Off by default: a journal that hits a
	 * bank account normally IS real cash, and the failure mode of guessing wrong the
	 * other way — bank movement the reconciliation can never see — is the one that hides.
	 */
	noBankMovement = false;
	postProgress = { done: 0, total: 0, transno: 0 };
	/**
	 * The profile the posted journal came from. Held separately because importing
	 * clears the upload (and with it payrollProfile), but the bank panel outlives
	 * that — and without the id the learned feed text has nowhere to go.
	 */
	payrollBankProfileId = 0;

	attachmentFiles: File[] = [];

	constructor(private route: ActivatedRoute, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder, public globalsService: GlobalsService, private modalService: NgbModal, public generalLedgerService: GeneralLedgerService, public printService: PrintService, private paymentsService: PaymentsService, private dialog: MatDialog) {

		this.color = this.globalSearchService.getColor();
	}

	/** GL codes that are also bank accounts — drives the "moves no money" prompt. */
	private bankAccountCodes = new Set<string>();

	/** True once any line lands on a bank account, i.e. the journal claims cash moved. */
	journalHitsBankAccount(): boolean {
		if (!this.bankAccountCodes.size || !this.debits_credits?.length) { return false; }
		return this.debits_credits.some((t: any) => {
			const code = t?.account?.accountcode ?? t?.account?.accountCode ?? '';
			return this.bankAccountCodes.has(String(code).trim());
		});
	}

	ngOnInit(): void {
		this.resetjournal = false;
		this.setForm();
		this.globalSearchService.bankaccounts.subscribe((accounts: any) => {
			this.bankAccountCodes = new Set(
				(accounts || [])
					.map((b: any) => String(b?.accountcode ?? '').trim())
					.filter((c: string) => c !== '' && c !== '__ADJ__')
			);
		});
		const navigation = this.router.getCurrentNavigation();
		const navState = (navigation?.extras?.state || history.state) as { reversalLines?: any[]; reversalJournalNumber?: string; reversalDate?: string } | undefined;
		forkJoin([
			this.globalsService.getGLAccounts(),
			this.generalLedgerService.getTags(),
			this.globalsService.getAccountSections(),
			this.generalLedgerService.getGlCloseStatus().pipe(catchError(() => of(null)))
		]).subscribe(([accounts, tagsResponse, sections, closeStatus]: [any, any, any, any]) => {
			this.glaccounts = accounts;
			this.allglaccounts = accounts;
			this.filteredOptions = accounts as any;
			this.tags = (tagsResponse && tagsResponse.tags) ? tagsResponse.tags : [];
			const sectionList = Array.isArray(sections) ? sections : (sections?.rows || []);
			const expenseSection = sectionList.find((s: any) => (s.sectionname || s.sectionName || '') === 'Expense');
			this.expenseSectionId = expenseSection ? (expenseSection.sectionid || expenseSection.sectionId || null) : null;
			this.glClosedThroughDate = closeStatus && closeStatus.closed_through_date ? String(closeStatus.closed_through_date) : null;
			this.glDepartmentRequired = closeStatus ? closeStatus.department_required !== false : true;
			this.globalsService.getCurrencies().subscribe((results: any) => {
				this.currencies = results;
			});
			if (navState?.reversalLines?.length) {
				this.debits_credits = this.normalizeReversalLines(navState.reversalLines, accounts);
				/*
				 * A reversal is dated as of the entry it reverses, not as of today.
				 * Backing an accrual out in the month it was booked is the whole point;
				 * dating it today moves the effect into a period that never had the
				 * original. If that month is closed the server rolls the posting forward
				 * and the panel says so before Post is pressed.
				 */
				const reversalDate = this.ymdToLocalDate(navState.reversalDate)
					?? this.ymdToLocalDate(this.lineTranYmd(this.debits_credits[0]))
					?? this.now;
				this.accountForm.get('trandate').setValue(reversalDate);
				this.reversalJournalNumber = navState.reversalJournalNumber ?? null;
				this.cdr.detectChanges();
			}
		});
	}

	private normalizeReversalLines(lines: any[], accounts: any[]): any[] {
		return lines.map((line: any) => {
			const accountCode = line?.account?.accountcode || line?.account?.accountCode || line?.accountCode;
			const matchedAccount = accounts.find((acc: any) => acc.accountcode === accountCode);

			return {
				...line,
				account: matchedAccount || line.account
			};
		});
	}

	private getLineTagId(line: any): string {
		const d = line?.department;
		if (d == null) { return ''; }
		if (d && (d.tagId !== undefined || d.tagref !== undefined)) { return String(d.tagId ?? d.tagref ?? ''); }
		return typeof d === 'string' ? d : '';
	}

	private hasExpenseAccount(lines: any[], _expenseSectionId?: string | null): boolean {
		if (!lines?.length) { return false; }
		return lines.some((line: any) => this.isAccountDepartmentRequired(line?.account));
	}


	addGl(event: any) {
		const selection = event?.option?.value ?? event;
		this.accountForm.get('account').setValue(selection);
		this.updateDepartmentRequiredState(selection);
	}

	private updateDepartmentRequiredState(account: any) {
		const deptControl = this.accountForm?.get('department');
		if (!deptControl) { return; }
		const isRequired = this.isAccountDepartmentRequired(account);
		if (isRequired) {
			deptControl.setValidators([Validators.required]);
		} else {
			deptControl.clearValidators();
		}
		deptControl.updateValueAndValidity();
		this.cdr.detectChanges();
	}

	private isAccountDepartmentRequired(account: any): boolean {
		if (!account) { return false; }
		return account.department_required === 1 || account.department_required === '1' || account.department_required === true;
	}

	isDepartmentRequired(): boolean {
		const account = this.accountForm?.get('account')?.value;
		return this.isAccountDepartmentRequired(account);
	}


	setForm() {


		this.accountForm = this.fb.group({
			/*
			 * A Date, not an ISO string. A posting date is a calendar fact: read
			 * `toISOString()` at 8pm local and the leading Y-m-d the server posts under
			 * is TOMORROW, while the picker still shows today. Holding the Date and
			 * normalizing with local parts at post time keeps the two the same day.
			 */
			trandate: [ this.now, [Validators.required]],
			type: ['normal',[Validators.required]],
			currcode: [''],
			exrate: [1],
			account: ['', [Validators.required]],
			description: ['', [Validators.required]],
			debitcredit: [0, [Validators.required]],
			entryType: ['debit', [Validators.required]],
			department: [null],
		});

		this.accountForm.get('currcode').valueChanges.subscribe((code: string) => {
			if (!code) {
				this.accountForm.get('exrate').setValue(1, { emitEvent: false });
			} else {
				const cur = (this.currencies || []).find((c: any) => c.currabrev === code);
				if (cur && parseFloat(cur.rate) > 0) {
					this.accountForm.get('exrate').setValue(parseFloat(cur.rate), { emitEvent: false });
				}
			}
		});
	}

	getFunctionalEquivalent(): number {
		const amount = Math.abs(parseFloat(this.accountForm.get('debitcredit').value)) || 0;
		const exrate = parseFloat(this.accountForm.get('exrate').value) || 1;
		const currcode = this.accountForm.get('currcode').value;
		if (!currcode || exrate <= 0) { return amount; }
		return amount / exrate;
	}

	loadData() {
		this.globalsService.getGLAccounts().subscribe((results: any) => {
			this.glaccounts = results;
			this.allglaccounts = results;
			this.filteredOptions = results;
			this.refreshGlUploadValidation();
		});
		this.globalsService.getCurrencies().subscribe((results: any) => {
			this.currencies = results;
		});
		this.generalLedgerService.getTags().subscribe((r: any) => {
			this.tags = r.tags || [];
		});
		this.generalLedgerService.getGlCloseStatus().pipe(catchError(() => of(null))).subscribe((s: any) => {
			this.glClosedThroughDate = s && s.closed_through_date ? String(s.closed_through_date) : null;
			this.glDepartmentRequired = s ? s.department_required !== false : true;
			this.refreshGlUploadValidation();
		});
	}

	getFormValidationErrors() {
		Object.keys(this.accountForm.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = this.accountForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					this.accountForm.markAllAsTouched();
					this.accountForm.markAsUntouched()

					if (key == 'reference') {
						key = 'PO Number';
					}

					this.globalSearchService.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}

	getCreditTotal() : number {
		let value = 0.00;
		if(this.debits_credits.length) {
			value = this.debits_credits.reduce(function(accumulator: number, items: any) {
				if(parseFloat(items.debitcredit) < 0) {
					 accumulator = accumulator + Math.abs(parseFloat(items.debitcredit));
				}
				return accumulator
			}, 0) ;
		}
		return value;
	}

	getDebitTotal() : number {
		let value = 0.00;
		if(this.debits_credits.length) {
			value = this.debits_credits.reduce(function(accumulator: number, items: any) {
				if(parseFloat(items.debitcredit) >= 0) {
					 accumulator = accumulator + parseFloat(items.debitcredit);
				}
				return accumulator
			}, 0) ;
		}
		return value;

	}

	requiredToBalance(): number {
		let value = 0.00;
		if(this.debits_credits.length) {
			value = this.debits_credits.reduce(function(accumulator: number, items: any) {
				return accumulator + parseFloat(items.debitcredit);
			}, 0) ;
		}
		return value;
	}

	isBalanced(): boolean {
		return Math.abs(this.requiredToBalance()) < 0.005;
	}

	/* ---------- posting dates ----------
	 *
	 * Every line carries its own date — it is snapshotted off the form when the line
	 * is added, so changing the Transaction Date afterwards does NOT move lines that
	 * are already in the grid. That, plus the closed-period roll-forward, is why the
	 * date each line will actually post under is shown in the grid rather than left
	 * to be discovered in the trial balance.
	 */

	/** The Y-m-d this line was keyed under — the same 10 characters the server reads. */
	lineTranYmd(line: any): string {
		const r = this.resolveGlUploadDateValue(line?.trandate);
		return r.ok ? r.iso : '';
	}

	/** Y-m-d currently in the Transaction Date field. */
	headerTranYmd(): string {
		const r = this.resolveGlUploadDateValue(this.accountForm?.get('trandate')?.value);
		return r.ok ? r.iso : '';
	}

	todayYmd(): string {
		const r = this.localDateToYmd(new Date());
		return r.ok ? r.iso : '';
	}

	/** Keyed date falls in the closed GL, so the server will roll it forward to today. */
	lineDateClosed(line: any): boolean {
		const ymd = this.lineTranYmd(line);
		return !!(ymd && this.glClosedThroughDate && ymd <= this.glClosedThroughDate);
	}

	/** The date the line lands on once the closed-period policy is applied. */
	lineEffectiveYmd(line: any): string {
		return this.lineDateClosed(line) ? this.todayYmd() : this.lineTranYmd(line);
	}

	/** Distinct posting dates across the grid, earliest first. */
	journalPostingDates(): string[] {
		const seen = new Set<string>();
		for (const line of this.debits_credits || []) {
			const ymd = this.lineEffectiveYmd(line);
			if (ymd) { seen.add(ymd); }
		}
		return Array.from(seen).sort();
	}

	closedDateLineCount(): number {
		return (this.debits_credits || []).filter((l: any) => this.lineDateClosed(l)).length;
	}

	/** Lines keyed under a date other than the one in the form right now. */
	linesOffHeaderDate(): number {
		const header = this.headerTranYmd();
		if (!header) { return 0; }
		return (this.debits_credits || []).filter((l: any) => {
			const ymd = this.lineTranYmd(l);
			return ymd !== '' && ymd !== header;
		}).length;
	}

	/** Re-date every line in the grid to the Transaction Date field. Always explicit. */
	applyHeaderDateToAllLines(): void {
		const value = this.accountForm?.get('trandate')?.value;
		if (!this.headerTranYmd()) { return; }
		this.debits_credits = (this.debits_credits || []).map((l: any) => ({ ...l, trandate: value }));
		this.cdr.detectChanges();
	}

	/** Y-m-d to a local-midnight Date, which is what the datepicker wants. */
	private ymdToLocalDate(ymd: string | null | undefined): Date | null {
		if (!ymd) { return null; }
		const m = String(ymd).match(/^(\d{4})-(\d{2})-(\d{2})$/);
		if (!m) { return null; }
		const d = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
		return isNaN(d.getTime()) ? null : d;
	}

	addValue() {
		if(this.accountForm.valid) {
			const amount = parseFloat(this.accountForm.get('debitcredit').value);
			if(!amount && this.editingIndex === null) { return; }
			const entryType = this.accountForm.get('entryType').value;
			const entryData = { ...this.accountForm.value };
			entryData.debitcredit = entryType === 'debit' ? amount : -amount;

			if (this.editingIndex !== null) {
				this.debits_credits[this.editingIndex] = entryData;
				this.cancelEdit();
			} else {
				this.debits_credits.push(entryData);
				this.accountForm.patchValue({
					account: '',
					description: '',
					debitcredit: 0
				});
				this.updateDepartmentRequiredState(null);
				this.resetjournal = true;
				setTimeout(() => { this.resetjournal = false; }, 100);
			}
		} else {
			this.getFormValidationErrors();
		}
	}

	editLine(line: any, index: number) {
		this.editingIndex = index;
		this.preselectedAccount = line.account;
		/*
		 * The line's own date goes into the field, so an edit shows the date the line
		 * actually carries and re-dates it only if the operator changes it. Held and
		 * restored on the way out, otherwise the next line added would silently inherit
		 * the date of the one just edited.
		 */
		const lineDate = this.ymdToLocalDate(this.lineTranYmd(line));
		// Only on the way IN to editing — hopping straight from one line to another
		// must not overwrite the operator's own date with the last line's.
		if (lineDate && this.headerDateBeforeEdit === null) {
			this.headerDateBeforeEdit = this.accountForm.get('trandate').value;
		}
		this.accountForm.patchValue({
			account: line.account,
			description: line.description,
			entryType: line.debitcredit >= 0 ? 'debit' : 'credit',
			debitcredit: Math.abs(parseFloat(line.debitcredit)),
			department: line.department ?? null,
			currcode: line.currcode || '',
			exrate: line.exrate || 1,
			...(lineDate ? { trandate: lineDate } : {}),
		});
		this.updateDepartmentRequiredState(line.account);
	}

	cancelEdit() {
		this.editingIndex = null;
		this.preselectedAccount = null;
		this.accountForm.patchValue({
			account: '',
			description: '',
			debitcredit: 0,
			...(this.headerDateBeforeEdit !== null ? { trandate: this.headerDateBeforeEdit } : {}),
		});
		this.headerDateBeforeEdit = null;
		this.updateDepartmentRequiredState(null);
		this.resetjournal = true;
		setTimeout(() => { this.resetjournal = false; }, 100);
	}

	removeDC(debitcredit: any) {
		const index = this.debits_credits.indexOf(debitcredit);
		if(index < 0) {

		} else {
			this.debits_credits.splice(index,1);
		}
	}

	private handleJournalPostResult(result: any, onSuccess?: () => void) {
		const color = result?.success ? 'success' : 'danger';
		this.globalSearchService.showNotification(result?.message || (result?.success ? 'Journal posted' : 'Post failed'), color, 'bottom', 'center');
		if (result?.success && result?.date_adjusted) {
			const req = result.requested_date || '';
			const eff = result.effective_date || '';
			const detail = req && eff ? ` Requested: ${req} → Posted: ${eff}.` : ' Posting date was moved to today (period was closed).';
			this.globalSearchService.showNotification('Period was closed.' + detail, 'warning', 'bottom', 'center');
		}
		if (result?.success && onSuccess) {
			onSuccess();
		}
	}

	openJournalGlPreview(): void {
		if (!this.debits_credits.length) {
			this.globalSearchService.showNotification('Add journal lines first.', 'info', 'bottom', 'right');
			return;
		}
		const lines: GlPreviewLine[] = this.debits_credits.map((d: any) => {
			const raw = Number(d.debitcredit);
			const amt = Math.abs(raw);
			const side: 'debit' | 'credit' = raw >= 0 ? 'debit' : 'credit';
			const acct = d.account || {};
			return {
				account: acct.accountcode ?? '',
				account_name: acct.accountname ?? '',
				narrative: d.description || '',
				amount: amt,
				side,
				// What the line will post under, closed-period roll-forward included.
				trandate: this.lineEffectiveYmd(d),
				date_adjusted: this.lineDateClosed(d),
			};
		});
		const closed = this.closedDateLineCount();
		this.dialog.open(GlPreviewModalComponent, {
			width: '1160px',
			maxWidth: '98vw',
			panelClass: 'gl-preview-dialog-panel',
			data: {
				title: 'Journal entry — GL preview',
				getPreview: (_excludeTypenos?: number[], _sampleScope?: 'all' | 'current_year') =>
					of({
						success: true,
						lines,
						meta: closed ? {
							assumptions: [
								`${closed} line(s) are dated on or before the GL close (${this.glClosedThroughDate}) — those post to ${this.todayYmd()}.`
							]
						} : undefined,
					}),
			} as GlPreviewModalData,
		});
	}

	postJournal() {
		if (this.debits_credits.length) {
			const dept = this.accountForm.get('department').value;
			const glTag = (dept && dept.tagId !== undefined) ? dept.tagId : (dept || '');
			if (this.hasExpenseAccount(this.debits_credits)) {
				const glTagStr = glTag !== '' && glTag != null ? String(glTag) : '';
				for (const t of this.debits_credits) {
					if (!this.isAccountDepartmentRequired(t?.account)) { continue; }
					const effective = this.getLineTagId(t) || glTagStr;
					if (!effective) {
						this.globalSearchService.showNotification('Department is required for this GL account.', 'danger', 'bottom', 'center');
						return;
					}
				}
			}
			const transactions = this.debits_credits.map((t: any) => ({
				...t,
				// Sent as the plain Y-m-d shown in the grid, so the date that posts is the
				// date the operator was looking at — not a UTC restatement of it.
				trandate: this.lineTranYmd(t) || this.todayYmd(),
				tag: this.getLineTagId(t) || glTag || undefined
			}));
			// A payroll layout can carry the tag the whole journal belongs under
			// (Cleve: PAYROLL), so the operator does not re-pick it every run.
			const effectiveGlTag = glTag || (this.payrollPendingDrop ? (this.payrollProfileDefaultTag || '') : '');
			const cashLines = this.collectPayrollCashLines();
			// Captured before the success handler clears it — that is where the
			// original journal's number lives, and releasing its bank lines depends
			// on still knowing it.
			const reversedJournal = this.reversalJournalNumber;
			this.postJournalInBatches(transactions, effectiveGlTag || '').then((result: any) => {
				this.handleJournalPostResult(result, () => {
					this.editingIndex = null;
					this.preselectedAccount = null;
					this.reversalJournalNumber = null;
					this.setForm();
					this.resetjournal = true;
					setTimeout(() => { this.resetjournal = false; }, 100);
					this.debits_credits = [];
					if (result.transno && this.attachmentFiles.length > 0) {
						this.uploadAttachmentFiles(result.transno);
					}
					// reversalJournalNumber is typed as a string but carries a journal
					// number; coerce and guard so a bad value skips the call rather
					// than posting transno 0.
					const reversedNo = Number(reversedJournal);
					if (reversedNo > 0) {
						this.releaseReversedJournalBankLines(reversedNo);
					}
					if (result.transno) {
						this.afterPayrollPost(Number(result.transno), cashLines);
					}
				});
			});
		}
	}


	/**
	 * Post a journal in chunks, as one journal.
	 *
	 * The first request allocates the transno; the rest append to it; the last
	 * finalizes, which is where the server proves the whole thing balances and
	 * deletes it if it doesn't. Small journals (one chunk) take the same path with
	 * finalize on the only request, so there is one code path, not two.
	 *
	 * Sequential on purpose. Parallel chunks would race for the transno on the
	 * first request and there is nothing to gain — the point is to stay under the
	 * timeout, not to go faster.
	 */
	private async postJournalInBatches(transactions: any[], glTag: string): Promise<any> {
		const size = this.postBatchSize;
		const chunks: any[][] = [];
		for (let i = 0; i < transactions.length; i += size) {
			chunks.push(transactions.slice(i, i + size));
		}
		if (!chunks.length) {
			return { success: false, message: 'Nothing to post.' };
		}

		this.posting = true;
		this.postProgress = { done: 0, total: transactions.length, transno: 0 };
		let transno = 0;
		let last: any = null;

		try {
			for (let i = 0; i < chunks.length; i++) {
				const isLast = i === chunks.length - 1;
				const payload: any = {
					transactions: chunks[i],
					gl_tag: glTag,
				};
				// Sent on EVERY chunk — the server decides per request, so omitting it
				// on a later chunk would mirror the tail of a reclass into the bank.
				if (this.noBankMovement) { payload.no_bank_movement = 1; }
				if (transno > 0) { payload.batch_transno = transno; }
				if (isLast) { payload.batch_finalize = 1; }

				const res: any = await this.generalLedgerService.postJournalEntry(payload).toPromise();
				if (!res || !res.success) {
					// The server already deleted the journal on its own failure paths;
					// abort covers the case where it answered but we cannot continue.
					await this.abortPartialJournal(transno);
					this.posting = false;
					return res || { success: false, message: 'Post failed — no response from the server.' };
				}
				transno = Number(res.transno) || transno;
				last = res;
				this.postProgress = {
					done: Math.min(this.postProgress.done + chunks[i].length, transactions.length),
					total: transactions.length,
					transno,
				};
				this.cdr.detectChanges();
			}
		} catch (e) {
			// A dropped connection mid-batch is exactly the case this exists to
			// survive: leaving the half-written journal behind would put an
			// unbalanced entry into the trial balance.
			await this.abortPartialJournal(transno);
			this.posting = false;
			return { success: false, message: 'Post failed part way through — the partial journal was discarded.' };
		}

		this.posting = false;
		return last;
	}

	private async abortPartialJournal(transno: number): Promise<void> {
		if (!transno) { return; }
		try {
			await this.generalLedgerService.postJournalEntry({
				transactions: [],
				batch_transno: transno,
				batch_abort: 1,
			}).toPromise();
		} catch {
			this.globalSearchService.showNotification(
				`Journal #${transno} may be partially written and could not be discarded automatically — check it before re-posting.`,
				'danger',
				'bottom',
				'center'
			);
		}
	}

	/** Debit / credit / difference for whatever is currently in the journal grid. */
	get journalTotals() {
		const debit = this.getDebitTotal();
		const credit = this.getCreditTotal();
		return { debit, credit, difference: debit - credit };
	}

	exportPdf() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: 'jounral_entry',
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;
		});
	}

	exportXls() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: 'jounral_entry',
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}
	announceSortChange(sortState: Sort) {

	}

	displayFn(account: any): string {
		return account.accountname
	}

	back(): void {
		this.location.back()
	}

	onAttachmentSelect(event: { addedFiles: File[] }) {
		this.attachmentFiles.push(...event.addedFiles);
	}

	onAttachmentRemove(file: File) {
		this.attachmentFiles = this.attachmentFiles.filter(f => f !== file);
	}

	private readFileAsDataUrl(file: File): Promise<string | ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result);
			reader.onerror = () => reject(reader.error);
			reader.readAsDataURL(file);
		});
	}

	private uploadAttachmentFiles(transno: number) {
		if (this.attachmentFiles.length === 0) {
			return;
		}
		const uploads = this.attachmentFiles.map((file: File) =>
			from(this.readFileAsDataUrl(file)).pipe(
				switchMap((content: string) => this.generalLedgerService.uploadJournalAttachment(transno, {
					content: content as string,
					name: file.name,
					mime: file.type || 'application/octet-stream'
				}))
			)
		);
		forkJoin(uploads).subscribe({
			next: () => {
				this.globalSearchService.showNotification('Attachments uploaded', 'success', 'bottom', 'center');
				this.attachmentFiles = [];
			},
			error: () => {
				this.globalSearchService.showNotification('Some attachments failed to upload', 'warning', 'bottom', 'center');
				this.attachmentFiles = [];
			}
		});
	}

	onGlUploadChange(event: Event) {
		const input = event.target as HTMLInputElement;
		if (input.files?.length) {
			this.glUploadFiles = Array.from(input.files);
			this.processGlFiles();
		}
	}

	onGlDropzoneDragOver(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.glDropzoneActive = true;
	}

	onGlDropzoneDragLeave(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.glDropzoneActive = false;
	}

	onGlDropzoneDrop(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.glDropzoneActive = false;
		const files = event.dataTransfer?.files;
		if (files?.length) {
			this.glUploadFiles = Array.from(files).filter(f => /\.(csv|xlsx|xls)$/i.test(f.name));
			if (this.glUploadFiles.length) {
				this.processGlFiles();
			}
		}
	}

	private readGlFile(file: File): Promise<ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result as ArrayBuffer);
			reader.onerror = () => reject(reader.error);
			reader.readAsArrayBuffer(file);
		});
	}

	private parseCsvLine(line: string): string[] {
		const out: string[] = [];
		let cur = '';
		let inQuotes = false;
		for (let i = 0; i < line.length; i++) {
			const c = line[i];
			if (inQuotes) {
				if (c === '"') {
					if (line[i + 1] === '"') {
						cur += '"';
						i++;
					} else {
						inQuotes = false;
					}
				} else {
					cur += c;
				}
			} else if (c === '"') {
				inQuotes = true;
			} else if (c === ',') {
				out.push(cur);
				cur = '';
			} else {
				cur += c;
			}
		}
		out.push(cur);
		return out.map(s => s.trim());
	}

	private parseCsvTextToRows(text: string): Record<string, any>[] {
		const lines = text.split(/\r?\n/).filter(l => l.trim().length > 0);
		if (lines.length < 2) {
			return [];
		}
		const headerCells = this.parseCsvLine(lines[0]).map(h => h.replace(/^\ufeff/, '').trim());
		const rows: Record<string, any>[] = [];
		for (let li = 1; li < lines.length; li++) {
			const cells = this.parseCsvLine(lines[li]);
			const obj: Record<string, any> = {};
			headerCells.forEach((h, idx) => {
				obj[h] = cells[idx] ?? '';
			});
			rows.push(obj);
		}
		return rows;
	}

	/** Map common spreadsheet headers to upload field names (first match wins per field). */
	private inferGlColumnFieldFromHeader(header: string): string | null {
		const norm = header.replace(/^\ufeff/, '').trim().toLowerCase().replace(/\s+/g, ' ');
		const aliases: [string, string][] = [
			['transaction date', 'trandate'],
			['posting date', 'trandate'],
			['tran date', 'trandate'],
			['gl date', 'trandate'],
			['journal date', 'trandate'],
			['date', 'trandate'],
			['gl account', 'account'],
			['account code', 'account'],
			['accountcode', 'account'],
			['acct code', 'account'],
			['acct', 'account'],
			['gl code', 'account'],
			['debit/credit', 'debitcredit'],
			['debit credit', 'debitcredit'],
			['amount', 'debitcredit'],
			['net amount', 'debitcredit'],
			// Two-column form. Without these a payroll export maps neither amount
			// column, and mapping both to `debitcredit` by hand is worse than
			// useless — last-wins would post every credit as a debit.
			['debit amount', 'debit'],
			['debit amt', 'debit'],
			['dr', 'debit'],
			['credit amount', 'credit'],
			['credit amt', 'credit'],
			['cr', 'credit'],
			['memo', 'description'],
			['narrative', 'description'],
			['desc', 'description'],
			['dept', 'department'],
			['dept worked', 'department'],
			['department', 'department'],
			['tag', 'department'],
			['cost center', 'department'],
			['location', 'location'],
			['loc', 'location'],
		];
		for (const [needle, field] of aliases) {
			if (norm === needle) {
				return field;
			}
		}
		const direct = ['trandate', 'account', 'description', 'debitcredit', 'debit', 'credit', 'department', 'location'];
		return direct.includes(norm) ? norm : null;
	}

	async processGlFiles() {
		this.glUploadedRawData = [];
		this.glUploadedHeaders = [];
		this.glColumnMappings = {};
		this.glFileSha256 = '';
		this.glFileFormat = '';
		this.resetPayrollState();
		this.glParsing = true;
		this.cdr.detectChanges();
		for (const file of this.glUploadFiles) {
			try {
				const buf = await this.readGlFile(file);
				const ext = (file.name || '').split('.').pop()?.toLowerCase();
				this.glFileFormat = ext || '';
				// Hashed before parsing so the double-post guard keys off the exact
				// bytes the operator dropped, not our interpretation of them.
				if (!this.glFileSha256) {
					this.glFileSha256 = await this.sha256Hex(buf);
				}
				let rows: Record<string, any>[] = [];
				if (ext === 'xlsx' || ext === 'xls') {
					const workbook = XLSX.read(buf, { type: 'array', cellDates: true });
					const sheet = workbook.Sheets[workbook.SheetNames[0]];
					rows = XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false });
				} else if (ext === 'csv') {
					const text = new TextDecoder('utf-8', { fatal: false }).decode(buf);
					rows = this.parseCsvTextToRows(text);
				}
				if (rows.length && Object.keys(rows[0]).length) {
					const headers = Object.keys(rows[0]);
					this.glUploadedHeaders = [...new Set([...this.glUploadedHeaders, ...headers])];
					rows.forEach(r => this.glUploadedRawData.push({ ...r }));
				}
			} catch (e) {
				this.globalSearchService.showNotification('Error parsing file', 'danger', 'bottom', 'right');
			}
		}
		this.glMappingUserEdited = false;
		this.inferGlColumnMappings();
		this.glUploadReady = this.glUploadedRawData.length > 0;
		// A big file is not something to hand back with every row expanded.
		this.glRawDataExpanded = false;
		this.glRawShowAll = false;
		this.refreshGlUploadValidation();
		this.glParsing = false;
		this.cdr.detectChanges();
		if (this.glImportMode === 'payroll' && this.glUploadReady) {
			this.payrollInspect();
		}
	}

	clearGlUpload() {
		this.glUploadFiles = [];
		this.glUploadedRawData = [];
		this.glUploadedHeaders = [];
		this.glColumnMappings = {};
		this.glUploadReady = false;
		this.glDropzoneActive = false;
		this.glError = '';
		this.glUploadInvalidAccounts = [];
		this.glUploadInvalidDates = [];
		this.glUploadClosedPeriodHits = [];
		this.glFileSha256 = '';
		this.glFileFormat = '';
		this.resetPayrollState();
	}

	private isGlUploadColumnMapped(field: string): boolean {
		return Object.keys(this.glColumnMappings).some(h => this.glColumnMappings[h] === field);
	}

	private mapGlUploadRowToFields(row: Record<string, any>): Record<string, any> {
		const mapped: Record<string, any> = {};
		Object.keys(row).forEach(header => {
			const field = this.glColumnMappings[header];
			if (field && field !== 'ignore') {
				mapped[field] = row[header];
			}
		});
		return mapped;
	}

	private isValidCalendarYmd(y: number, mo: number, d: number): boolean {
		if (y < 1990 || y > 2100 || mo < 1 || mo > 12 || d < 1 || d > 31) {
			return false;
		}
		const dt = new Date(y, mo - 1, d);
		return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
	}

	private ymdPartsToIso(y: number, mo: number, d: number): string {
		return `${String(y).padStart(4, '0')}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
	}

	/** Excel serial date → calendar Y-m-d in UTC (avoids local TZ shifting the day vs Sheet). */
	private excelSerialToYmd(serial: number): { ok: true; iso: string } | { ok: false } {
		if (!Number.isFinite(serial)) {
			return { ok: false };
		}
		const whole = Math.floor(serial);
		if (whole < 1 || whole > 6000000) {
			return { ok: false };
		}
		const epochUtc = Date.UTC(1899, 11, 30) + whole * 86400000;
		const d = new Date(epochUtc);
		const y = d.getUTCFullYear();
		const mo = d.getUTCMonth() + 1;
		const day = d.getUTCDate();
		if (!this.isValidCalendarYmd(y, mo, day)) {
			return { ok: false };
		}
		return { ok: true, iso: this.ymdPartsToIso(y, mo, day) };
	}

	private localDateToYmd(d: Date): { ok: true; iso: string } | { ok: false } {
		if (!(d instanceof Date) || isNaN(d.getTime())) {
			return { ok: false };
		}
		const y = d.getFullYear();
		const mo = d.getMonth() + 1;
		const day = d.getDate();
		if (!this.isValidCalendarYmd(y, mo, day)) {
			return { ok: false };
		}
		return { ok: true, iso: this.ymdPartsToIso(y, mo, day) };
	}

	/**
	 * Parse upload / spreadsheet date values; invalid input returns ok: false (never silently substitute “today”).
	 * Uses local calendar parts for Date / Excel-native cells; Excel serials use the Excel UTC epoch.
	 */
	private resolveGlUploadDateValue(val: any): { ok: true; iso: string } | { ok: false } {
		if (val == null || val === '') {
			return { ok: false };
		}
		if (typeof val === 'number' && Number.isFinite(val)) {
			return this.excelSerialToYmd(val);
		}
		if (val instanceof Date) {
			return this.localDateToYmd(val);
		}
		const s = String(val).trim();
		if (!s) {
			return { ok: false };
		}
		const ymdHead = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (ymdHead) {
			const y = parseInt(ymdHead[1], 10);
			const mo = parseInt(ymdHead[2], 10);
			const d = parseInt(ymdHead[3], 10);
			return this.isValidCalendarYmd(y, mo, d) ? { ok: true, iso: this.ymdPartsToIso(y, mo, d) } : { ok: false };
		}
		const slash = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
		if (slash) {
			const a = parseInt(slash[1], 10);
			const b = parseInt(slash[2], 10);
			const y = parseInt(slash[3], 10);
			let mo: number;
			let day: number;
			if (a > 12) {
				day = a;
				mo = b;
			} else if (b > 12) {
				mo = a;
				day = b;
			} else {
				mo = a;
				day = b;
			}
			return this.isValidCalendarYmd(y, mo, day) ? { ok: true, iso: this.ymdPartsToIso(y, mo, day) } : { ok: false };
		}
		const parsed = new Date(s);
		if (!isNaN(parsed.getTime())) {
			return this.localDateToYmd(parsed);
		}
		return { ok: false };
	}

	/**
	 * Date for imported lines whose file carries none: the Transaction Date the
	 * operator set for this journal, falling back to today. Set the date, then import,
	 * and the lines land where the screen says they will.
	 */
	private defaultGlUploadTranIso(): string {
		const header = this.headerTranYmd();
		if (header) { return header; }
		const r = this.localDateToYmd(this.now);
		return r.ok ? r.iso : this.now.toISOString().slice(0, 10);
	}

	private normalizeUploadAccountCode(raw: any): string {
		if (raw == null || raw === '') {
			return '';
		}
		if (typeof raw === 'number' && Number.isFinite(raw)) {
			return Number.isInteger(raw) ? String(raw) : String(raw).trim();
		}
		return String(raw).trim();
	}

	private normalizeUploadDebitCredit(raw: any): number {
		if (raw == null || raw === '') {
			return NaN;
		}
		if (typeof raw === 'number' && Number.isFinite(raw)) {
			return raw;
		}
		let s = String(raw).trim().replace(/[$\s]/g, '').replace(/,/g, '');
		// Accounting negatives: (1,234.56) means −1234.56. Exports that use this
		// would otherwise parse as NaN and the line would silently vanish.
		const paren = s.match(/^\((.*)\)$/);
		if (paren) {
			s = '-' + paren[1];
		}
		return parseFloat(s);
	}

	/**
	 * Signed amount for an upload row, from either column shape.
	 * Two-column form wins when present: debit − credit.
	 */
	private resolveUploadAmount(mapped: Record<string, any>): number {
		if (this.isGlUploadColumnMapped('debit') || this.isGlUploadColumnMapped('credit')) {
			const d = this.normalizeUploadDebitCredit(mapped['debit']);
			const c = this.normalizeUploadDebitCredit(mapped['credit']);
			return (isNaN(d) ? 0 : d) - (isNaN(c) ? 0 : c);
		}
		return this.normalizeUploadDebitCredit(mapped['debitcredit']);
	}

	/** True once the file's amount is readable, whichever column shape it uses. */
	private hasUploadAmountColumn(): boolean {
		return this.isGlUploadColumnMapped('debitcredit')
			|| this.isGlUploadColumnMapped('debit')
			|| this.isGlUploadColumnMapped('credit');
	}

	refreshGlUploadValidation(): void {
		this.glUploadInvalidAccounts = [];
		this.glUploadInvalidDates = [];
		this.glUploadClosedPeriodHits = [];
		if (!this.glUploadedRawData.length) {
			this.recomputeGlUploadDerived();
			return;
		}
		const accountCodes = new Set((this.glaccounts || []).map((a: any) => (a.accountcode || '').toString().trim()));
		const accountMapped = this.isGlUploadColumnMapped('account');
		const trandateMapped = this.isGlUploadColumnMapped('trandate');
		if (accountMapped) {
			this.glUploadedRawData.forEach((row, idx) => {
				const rowNum = idx + 1;
				const mapped = this.mapGlUploadRowToFields(row);
				const code = this.normalizeUploadAccountCode(mapped['account']);
				const amt = this.resolveUploadAmount(mapped);
				const hasAmount = !isNaN(amt) && Math.abs(amt) > 1e-9;
				if (!hasAmount && !code) {
					return;
				}
				if (!code) {
					this.glUploadInvalidAccounts.push({ row: rowNum, code: '(missing)' });
				} else if (this.glImportMode === 'payroll') {
					// In payroll mode the file's code is the PROVIDER's, so it is the
					// translation that has to resolve — not the raw code. Unresolved codes
					// are reported by the mapping grid, not here, so they are actionable.
				} else if (!accountCodes.has(code)) {
					this.glUploadInvalidAccounts.push({ row: rowNum, code });
				}
				const rawTd = mapped['trandate'];
				if (trandateMapped && rawTd != null && String(rawTd).trim() !== '') {
					const dr = this.resolveGlUploadDateValue(rawTd);
					if (!dr.ok) {
						this.glUploadInvalidDates.push({ row: rowNum, value: String(rawTd) });
					} else if (this.glClosedThroughDate && dr.iso <= this.glClosedThroughDate) {
						this.glUploadClosedPeriodHits.push({ row: rowNum, date: dr.iso });
					}
				}
			});
		}
		// Always — the happy path used to skip this, so a correctly-mapped file kept
		// empty totals / zero lines-to-post until something else forced a rebuild.
		this.recomputeGlUploadDerived();
	}

	/**
	 * Rebuild the derived view of the upload once, here, instead of from the
	 * template. `hasRequiredGlMappings()` and the balance line are both bound in the
	 * view and both used to rebuild every row on every change-detection pass — fine
	 * for 45 lines, a hang for the thousands this is meant to take.
	 */
	private recomputeGlUploadDerived(): void {
		this.glUploadBuilt = this.glUploadedRawData.length ? this.buildGlTransactionsFromUpload() : [];
		let debit = 0;
		let credit = 0;
		for (const r of this.glUploadBuilt) {
			const v = Number(r.debitcredit) || 0;
			if (v >= 0) { debit += v; } else { credit += -v; }
		}
		this.glUploadTotals = {
			debit,
			credit,
			difference: debit - credit,
			lines: this.glUploadBuilt.length,
		};
	}

	glUploadValidationOk(): boolean {
		return this.glUploadInvalidAccounts.length === 0 && this.glUploadInvalidDates.length === 0;
	}

	onGlColumnMappingChange(header: string, value: string): void {
		this.glColumnMappings[header] = value;
		this.glMappingUserEdited = true;
		this.refreshGlUploadValidation();
		// Which column is `account` or `description` decides what needs translating,
		// so a mapping change invalidates the resolution that was based on it.
		if (this.glImportMode === 'payroll' && this.glUploadReady) {
			this.payrollInspect();
		}
	}

	downloadGlUploadTemplate() {
		const today = this.now.toISOString().slice(0, 10);
		const header = 'trandate,account,description,debitcredit,department';
		const sample1 = today + ',1000,Cash receipt,500.00,';
		const sample2 = today + ',63000,Admin expense,250.00,Operations';
		const sample3 = today + ',4000,Sales revenue,-750.00,';
		const csv = [header, sample1, sample2, sample3].join('\n');
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
		FileSaver.saveAs(blob, 'gl_journal_upload_template.csv');
	}

	/** Normalize department / tag description text for matching (hyphens, spaces, NBSP). */
	private normalizeDepartmentMatchKey(s: string): string {
		return (s || '')
			.replace(/\u00a0/g, ' ')
			.replace(/[\u2010-\u2015\u2212\ufe58\ufe63\uff0d]/g, '-')
			.replace(/\s+/g, ' ')
			.trim()
			.toLowerCase();
	}

	private resolveDepartmentFromUploadValue(val: any): any {
		if (val == null || val === '') { return null; }
		const s = (val + '').trim();
		if (!s) { return null; }
		const tags = this.tags || [];
		const byId = tags.find((t: any) => String(t.tagId || t.tagref || '') === s);
		if (byId) { return byId; }
		const key = this.normalizeDepartmentMatchKey(s);
		const byDesc = tags.find((t: any) => this.normalizeDepartmentMatchKey(t.description || '') === key);
		return byDesc || null;
	}

	buildGlTransactionsFromUpload(): { trandate: string; account: any; description: string; debitcredit: number; department: any }[] {
		const accountCodes = new Set((this.glaccounts || []).map((a: any) => (a.accountcode || '').toString().trim()));
		const out: any[] = [];
		const trandateMapped = this.isGlUploadColumnMapped('trandate');
		const payroll = this.glImportMode === 'payroll';
		for (const row of this.glUploadedRawData) {
			const mapped = this.mapGlUploadRowToFields(row);
			const sourceCode = this.normalizeUploadAccountCode(mapped['account']);
			if (!sourceCode) { continue; }
			const rawDesc = (mapped['description'] || '').toString();

			// Payroll: the file's code is the provider's, so translate it. An
			// unresolved code drops the line rather than guessing — the mapping grid
			// blocks the import until every one is answered, so this is unreachable
			// on the happy path and a safety net if it ever isn't.
			let code = sourceCode;
			let resolution: any = null;
			if (payroll) {
				resolution = this.payrollLookup(sourceCode, rawDesc);
				if (!resolution || !resolution.erpAccount) { continue; }
				code = resolution.erpAccount;
			}
			if (!accountCodes.has(code)) { continue; }

			let amt = this.resolveUploadAmount(mapped);
			if (isNaN(amt)) { amt = 0; }
			let trandateStr: string;
			const rawTd = mapped['trandate'];
			if (!trandateMapped || rawTd == null || String(rawTd).trim() === '') {
				trandateStr = this.defaultGlUploadTranIso();
			} else {
				const dr = this.resolveGlUploadDateValue(rawTd);
				if (!dr.ok) {
					continue;
				}
				trandateStr = dr.iso;
			}
			const department = this.resolveDepartmentFromUploadValue(mapped['department']);
			const accountObj = (this.glaccounts || []).find((a: any) => (a.accountcode || '').toString().trim() === code);
			if (!accountObj) { continue; }

			const line: any = {
				trandate: trandateStr,
				account: accountObj,
				description: payroll ? this.payrollNarrative(rawDesc, mapped, sourceCode) : rawDesc,
				debitcredit: amt,
				department,
			};
			if (payroll) {
				// Carried so the bank close-out knows which lines are cash and which
				// (code, description) taught it the feed text it matched on.
				line.payrollSourceCode = sourceCode;
				line.payrollSourceDesc = rawDesc;
				line.payrollIsCash = !!resolution.isCash;
				line.payrollMatchHint = resolution.matchHint || '';
			}
			out.push(line);
		}
		return out;
	}

	/**
	 * Keep the provider's cost dimensions in the narrative.
	 *
	 * Location / Dept Worked have no home in this ERP's chart (tags here are
	 * journal categories, not departments), and inventing a department dimension to
	 * hold them would be a much bigger change than the data justifies. Putting them
	 * in the narrative keeps the detail queryable in gltrans and visible in
	 * drill-down, which is what the numbers are actually for.
	 */
	private payrollNarrative(desc: string, mapped: Record<string, any>, sourceCode = ''): string {
		const parts: string[] = [];
		const loc = (mapped['location'] ?? '').toString().trim();
		const dept = (mapped['department'] ?? '').toString().trim();
		if (loc) { parts.push('Loc ' + loc); }
		if (dept) { parts.push('Dept ' + dept); }
		// Some payroll rows carry the meaning in the code and leave the description
		// blank ('DDD - HSA'). Falling back to the code keeps the GL narrative
		// readable instead of posting a bare ' — Loc 60 / Dept 6009'.
		const base = ((desc || '').replace(/\s+/g, ' ').trim()) || (sourceCode || '').trim();
		if (!base) { return parts.join(' / '); }
		return parts.length ? `${base} — ${parts.join(' / ')}` : base;
	}

	requiredToBalanceUpload(): number {
		return this.glUploadTotals.difference;
	}

	isUploadBatchBalanced(): boolean {
		return Math.abs(this.glUploadTotals.difference) < 0.005;
	}

	hasRequiredGlMappings(): boolean {
		const used = new Set<string>();
		Object.keys(this.glColumnMappings).forEach(h => { const v = this.glColumnMappings[h]; if (v && v !== 'ignore') { used.add(v); } });
		if (!used.has('account') || !this.hasUploadAmountColumn()) { return false; }
		if (this.glImportMode === 'payroll' && !this.payrollReadyToImport()) { return false; }
		const transactions = this.glUploadBuilt;
		if (this.glDepartmentRequired && this.hasExpenseAccount(transactions, this.expenseSectionId) && !used.has('department')) {
			return false;
		}
		if (this.glDepartmentRequired && this.hasExpenseAccount(transactions, this.expenseSectionId) && this.getFirstExpenseLineMissingDepartment(transactions)) {
			return false;
		}
		if (!this.glUploadValidationOk()) {
			return false;
		}
		return true;
	}

	private getFirstExpenseLineMissingDepartment(transactions: any[]): any | null {
		if (!transactions?.length) { return null; }
		for (const t of transactions) {
			if (!this.isAccountDepartmentRequired(t?.account)) { continue; }
			const tagId = this.getLineTagId(t);
			if (tagId === '' || tagId == null) { return t; }
		}
		return null;
	}

	/** Validates upload rows and merges them into the main journal grid (same path as manual lines → Post Journal). */
	importGlUploadToJournal(): void {
		this.glError = '';
		this.refreshGlUploadValidation();
		if (!this.glUploadValidationOk()) {
			this.glError = 'Fix invalid GL accounts or transaction dates before importing.';
			return;
		}
		const transactions = this.glUploadBuilt;
		if (!transactions.length) {
			this.glError = 'No valid lines (map account and an amount column; account must exist in GL)';
			return;
		}
		if (this.glDepartmentRequired && this.hasExpenseAccount(transactions, this.expenseSectionId)) {
			const missing = this.getFirstExpenseLineMissingDepartment(transactions);
			if (missing) {
				this.glError = 'Department is required for expense GL accounts. Map a column to "department" and provide a value (tag name or ID) for each expense line (accounts 6xxx/7xxx).';
				return;
			}
		}
		if (this.glImportMode === 'payroll') {
			// A payroll file that does not balance is a broken export, not something
			// to be balanced by hand afterwards. Standard mode still allows it
			// (partial batches are a legitimate workflow there); payroll does not.
			if (!this.isUploadBatchBalanced()) {
				this.glError = `This payroll file is out of balance by ${this.requiredToBalanceUpload().toFixed(2)}. Nothing was imported — re-export it.`;
				return;
			}
			if (this.payrollDuplicate && !this.payrollDuplicateOverridden) {
				this.glError = `This exact file already posted as journal #${this.payrollDuplicate.transno}. Tick the override if you really are re-running payroll.`;
				return;
			}
		}
		const journalType = this.accountForm.get('type')?.value || 'normal';
		const newLines = transactions.map((t: any) => ({
			trandate: t.trandate,
			type: journalType,
			account: t.account,
			description: t.description,
			debitcredit: t.debitcredit,
			entryType: t.debitcredit >= 0 ? 'debit' : 'credit',
			department: t.department ?? null,
			payrollSourceCode: t.payrollSourceCode,
			payrollSourceDesc: t.payrollSourceDesc,
			payrollIsCash: t.payrollIsCash,
			payrollMatchHint: t.payrollMatchHint,
		}));
		this.debits_credits = [...this.debits_credits, ...newLines];
		const n = newLines.length;
		if (this.glImportMode === 'payroll') {
			// Survives clearGlUpload() — postJournal() needs it to log the drop and
			// to know which posted lines are cash.
			this.payrollPendingDrop = {
				profile_id: this.payrollProfile?.id || 0,
				source_name: this.glUploadFiles[0]?.name || '',
				format: this.glFileFormat,
				sha256: this.glFileSha256,
				line_count: n,
				total_debit: newLines.reduce((a, l) => a + (l.debitcredit > 0 ? l.debitcredit : 0), 0),
				total_credit: newLines.reduce((a, l) => a + (l.debitcredit < 0 ? -l.debitcredit : 0), 0),
				feed_hint: this.payrollProfile?.feedHint || '',
			};
		}
		this.clearGlUpload();
		this.closeGlImportDialog();
		this.resetjournal = true;
		setTimeout(() => { this.resetjournal = false; }, 100);
		this.globalSearchService.showNotification(
			`Added ${n} line(s) from the file into this journal. Use Post Journal when the entry is balanced.`,
			'success',
			'bottom',
			'center'
		);
	}

	/* ------------------------------------------------------------------ *
	 * Payroll mode
	 * ------------------------------------------------------------------ */

	private async sha256Hex(buf: ArrayBuffer): Promise<string> {
		try {
			const digest = await crypto.subtle.digest('SHA-256', buf);
			return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, '0')).join('');
		} catch {
			// crypto.subtle needs a secure context. Degrade to no hash rather than
			// blocking the import — the server treats '' as "no guard available".
			return '';
		}
	}

	get payrollProfileDefaultTag(): string {
		return this.payrollProfile?.defaultTagref || '';
	}

	private resetPayrollState() {
		this.payrollProfile = null;
		this.payrollProfileName = '';
		this.payrollFeedHint = '';
		this.payrollResolved = {};
		this.payrollUnmapped = [];
		this.payrollDuplicate = null;
		this.payrollDuplicateOverridden = false;
		this.payrollBankAccounts = [];
		this.payrollFeedStatus = null;
		this.payrollNotice = '';
		this.payrollBusy = false;
	}

	/** Open the importer as a real dialog — it needs room for a mapping grid, not a sidebar. */
	private glImportDialogRef: any = null;

	openGlImportDialog() {
		this.glImportDialogRef = this.dialog.open(this.glImportDialogTpl, {
			width: '1400px',
			maxWidth: '96vw',
			height: '88vh',
			maxHeight: '88vh',
			panelClass: 'gl-import-dialog-panel',
			autoFocus: false,
			restoreFocus: true,
			// Closing mid-parse or mid-mapping loses nothing but is confusing, so
			// make it deliberate.
			disableClose: true,
		});
	}

	closeGlImportDialog() {
		if (this.glImportDialogRef) {
			this.glImportDialogRef.close();
			this.glImportDialogRef = null;
		}
	}

	/** Rows the raw grid actually renders — never the whole file unless asked. */
	glRawRows(): any[] {
		if (this.glRawShowAll) { return this.glUploadedRawData; }
		return this.glUploadedRawData.slice(0, this.glRawPreviewLimit);
	}

	glRawHiddenCount(): number {
		return Math.max(0, this.glUploadedRawData.length - this.glRawPreviewLimit);
	}

	/**
	 * Flipping the toggle re-runs the whole pipeline over the file already in hand.
	 * Dropping the file again to change your mind about the mode is busy-work, and
	 * leaving the previous mode's derived state on screen is worse than busy-work —
	 * the totals and the code list are both mode-dependent.
	 *
	 * Column mappings are only re-inferred when the operator hasn't touched them:
	 * re-deriving over someone's hand-corrections would throw away real work.
	 */
	setGlImportMode(mode: 'standard' | 'payroll') {
		if (this.glImportMode === mode) { return; }
		this.glImportMode = mode;
		this.glError = '';

		if (!this.glUploadReady) {
			if (mode === 'standard') { this.resetPayrollState(); }
			this.refreshGlUploadValidation();
			return;
		}

		if (!this.glMappingUserEdited) {
			this.inferGlColumnMappings();
		}

		if (mode === 'payroll') {
			this.payrollInspect();
		} else {
			this.resetPayrollState();
		}
		this.refreshGlUploadValidation();
	}

	/** Same normalisation the server uses, so a key built here matches one built there. */
	private normPayrollDesc(s: any): string {
		return (s ?? '').toString().replace(/\s+/g, ' ').trim().substring(0, 120);
	}

	private payrollKey(code: string, desc: any): string {
		return `${(code || '').trim()}${this.normPayrollDesc(desc)}`;
	}

	/**
	 * Translate one source code, server answer first, local pass-through second.
	 *
	 * The pass-through fallback is what keeps payroll mode a strict superset of
	 * standard mode: a code that IS one of your GL accounts (7400-1, 7410-1 …) must
	 * resolve to itself immediately, without waiting on — or depending on — the
	 * lookup. Otherwise turning the toggle on makes accounts that mapped fine a
	 * moment ago look unmapped, which reads as the mapping having been forgotten.
	 */
	private payrollLookup(code: string, desc: any): any {
		const hit = this.payrollResolved[this.payrollKey(code, desc)];
		if (hit) { return hit; }
		const clean = (code || '').trim();
		const account = (this.glaccounts || []).find((a: any) => (a.accountcode || '').toString().trim() === clean);
		if (!account) { return null; }
		return {
			sourceCode: clean,
			sourceDesc: this.normPayrollDesc(desc),
			erpAccount: clean,
			accountName: account.accountname || '',
			isCash: this.payrollBankAccountCodes().has(clean),
			matchHint: '',
			via: 'passthrough_local',
		};
	}

	private payrollBankAccountCodes(): Set<string> {
		return new Set((this.payrollBankAccounts || []).map((b: any) => (b.accountcode || '').toString().trim()));
	}

	/** Re-derive the column mapping from the headers alone. */
	private inferGlColumnMappings(): void {
		const assigned = new Set<string>();
		this.glColumnMappings = {};
		this.glUploadedHeaders.forEach(h => {
			const inferred = this.inferGlColumnFieldFromHeader(h);
			if (inferred && !assigned.has(inferred)) {
				this.glColumnMappings[h] = inferred;
				assigned.add(inferred);
			} else {
				this.glColumnMappings[h] = 'ignore';
			}
		});
	}

	/** Every distinct (code, description) pair in the file — what needs translating. */
	private payrollDistinctCodes(): { code: string; desc: string }[] {
		const seen = new Set<string>();
		const out: { code: string; desc: string }[] = [];
		for (const row of this.glUploadedRawData) {
			const mapped = this.mapGlUploadRowToFields(row);
			const code = this.normalizeUploadAccountCode(mapped['account']);
			if (!code) { continue; }
			const desc = this.normPayrollDesc(mapped['description']);
			const key = this.payrollKey(code, desc);
			if (seen.has(key)) { continue; }
			seen.add(key);
			out.push({ code, desc });
		}
		return out;
	}

	/**
	 * Ask the server what it already knows: the learned column layout, the
	 * translation for every code in this file, and whether these exact bytes have
	 * posted before.
	 */
	payrollInspect(afterMappingChange = false) {
		if (!this.glUploadedRawData.length) { return; }
		this.payrollBusy = true;
		this.payrollNotice = '';
		this.generalLedgerService.payrollImportInspect({
			headers: this.glUploadedHeaders,
			codes: this.payrollDistinctCodes(),
			sha256: this.glFileSha256,
			kind: 'payroll',
		}).subscribe({
			next: (r: any) => {
				this.payrollBusy = false;
				if (!r?.success) {
					this.payrollNotice = r?.error || 'Could not read the saved payroll settings.';
					return;
				}
				this.payrollProfile = r.profile || null;
				this.payrollProfileName = this.payrollProfile?.name || '';
				this.payrollFeedHint = this.payrollProfile?.feedHint || '';
				this.payrollBankAccounts = r.bankaccounts || [];
				this.payrollFeedStatus = r.feedStatus || null;
				// Older servers omit feedStatus — probe SimpleFIN ourselves so the
				// bank-configured card still appears before that deploy lands.
				if (!this.payrollFeedStatus) {
					this.loadPayrollFeedStatusFallback();
				}
				this.payrollDuplicate = r.duplicate || null;

				// A saved layout wins over header sniffing — it is what an operator
				// already confirmed for this exact file shape. Not over the operator's
				// own edits in this session, though.
				let mappingChanged = false;
				const saved = this.payrollProfile?.mapping;
				if (!this.glMappingUserEdited && saved && typeof saved === 'object' && Object.keys(saved).length) {
					this.glUploadedHeaders.forEach(h => {
						if (saved[h] && this.glColumnMappings[h] !== saved[h]) {
							this.glColumnMappings[h] = saved[h];
							mappingChanged = true;
						}
					});
				}

				// The codes we just asked about were read through the OLD mapping. If
				// the saved layout moved the account or description column, that answer
				// describes a file we are no longer reading — ask again, once. The
				// afterMappingChange guard is what stops this becoming a loop.
				if (mappingChanged && !afterMappingChange) {
					this.refreshGlUploadValidation();
					this.payrollInspect(true);
					return;
				}

				this.payrollResolved = {};
				(r.resolved || []).forEach((x: any) => {
					this.payrollResolved[this.payrollKey(x.sourceCode, x.sourceDesc)] = x;
				});
				// Never ask about a code that is already one of our GL accounts. The
				// server passes those through too, so this only fires if the two
				// disagree — and when they do, the chart is the authority.
				const chartCodes = new Set((this.glaccounts || []).map((a: any) => (a.accountcode || '').toString().trim()));
				this.payrollUnmapped = (r.unmapped || [])
					.filter((u: any) => !chartCodes.has((u.sourceCode || '').trim()))
					.map((u: any) => ({
						sourceCode: u.sourceCode,
						sourceDesc: u.sourceDesc,
						pick: '',
					}));
				this.refreshGlUploadValidation();
				this.cdr.detectChanges();
			},
			error: () => {
				this.payrollBusy = false;
				// Distinguishable on purpose: this is what a client running ahead of
				// the server looks like, and it is otherwise indistinguishable from
				// "nothing is mapped yet".
				this.payrollNotice = 'The payroll import service did not answer — apir/generalledger/payrollimport is probably not deployed on this server yet. Payroll mode cannot map codes until it is.';
			},
		});
	}

	/** Import is blocked until the layout is named, every code resolves, and any re-post is acknowledged. */
	payrollReadyToImport(): boolean {
		if (!this.payrollProfile) { return false; }
		if (this.payrollUnmapped.length) { return false; }
		if (this.payrollDuplicate && !this.payrollDuplicateOverridden) { return false; }
		return true;
	}

	/** Name (or rename) this file layout so the next export of the same shape needs no clicks. */
	savePayrollProfile() {
		const name = (this.payrollProfileName || '').trim();
		if (!name) {
			this.payrollNotice = 'Give the layout a name — usually the payroll provider.';
			return;
		}
		this.payrollBusy = true;
		this.generalLedgerService.payrollImportSaveProfile({
			profile_id: this.payrollProfile?.id || 0,
			name,
			kind: 'payroll',
			headers: this.glUploadedHeaders,
			mapping: this.glColumnMappings,
			default_tagref: this.payrollProfile?.defaultTagref || '',
			feed_hint: (this.payrollFeedHint || '').trim(),
		}).subscribe({
			next: (r: any) => {
				this.payrollBusy = false;
				if (!r?.success) {
					this.payrollNotice = r?.error || 'Could not save the layout.';
					return;
				}
				this.payrollProfile = r.profile;
				this.payrollNotice = `Layout "${name}" saved — the next file with these columns maps itself.`;
				this.payrollInspect();
			},
			error: () => { this.payrollBusy = false; this.payrollNotice = 'Could not save the layout.'; },
		});
	}

	/** Persist the operator's code → GL account answers, then re-resolve the file. */
	savePayrollMappings() {
		if (!this.payrollProfile?.id) {
			this.payrollNotice = 'Save the file layout first.';
			return;
		}
		const rows = this.payrollUnmapped
			.filter(u => (u.pick || '').trim() !== '')
			.map(u => ({
				source_code: u.sourceCode,
				source_desc: u.sourceDesc,
				erp_account: (u.pick || '').trim(),
			}));
		if (!rows.length) {
			this.payrollNotice = 'Pick a GL account for at least one code first.';
			return;
		}
		this.payrollBusy = true;
		this.generalLedgerService.payrollImportSaveMap({ profile_id: this.payrollProfile.id, rows }).subscribe({
			next: (r: any) => {
				this.payrollBusy = false;
				if (!r?.success) {
					this.payrollNotice = r?.error || 'Some mappings were rejected.';
				}
				this.payrollInspect();
			},
			error: () => { this.payrollBusy = false; this.payrollNotice = 'Could not save the mappings.'; },
		});
	}

	/** Accounts filtered for one row of the unmapped grid. */
	payrollAccountOptions(term: string): any[] {
		const t = (term || '').toLowerCase().trim();
		const all = this.glaccounts || [];
		if (!t) { return all.slice(0, 30); }
		return all.filter((a: any) =>
			(a.accountcode || '').toString().toLowerCase().includes(t) ||
			(a.accountname || '').toString().toLowerCase().includes(t)
		).slice(0, 30);
	}

	/** How the account a code now points at should read back to the operator. */
	payrollResolutionFor(code: string, desc: string): any {
		return this.payrollLookup(code, desc);
	}

	payrollResolvedList(): any[] {
		return Object.keys(this.payrollResolved).map(k => this.payrollResolved[k]);
	}

	payrollCashResolvedList(): any[] {
		return this.payrollResolvedList().filter(r => r.isCash);
	}

	/** Unique ERP bank accounts the current file's cash lines will post to. */
	payrollCashErpAccounts(): string[] {
		const seen = new Set<string>();
		const out: string[] = [];
		for (const r of this.payrollCashResolvedList()) {
			const code = (r.erpAccount || '').toString().trim();
			if (!code || seen.has(code)) { continue; }
			seen.add(code);
			out.push(code);
		}
		return out;
	}

	/** Cash accounts in this file that the feed cannot see. */
	payrollCashUnreadyAccounts(): string[] {
		const ready = new Set((this.payrollFeedStatus?.readyAccounts || []).map(a => (a || '').toString().trim()));
		return this.payrollCashErpAccounts().filter(c => !ready.has(c));
	}

	/**
	 * Bank feed is usable for close-out: SimpleFIN connected or feed rows exist,
	 * and every cash account this file will post to is in that set. No cash lines
	 * yet ⇒ "configured" means the tenant has at least one feed-ready bank account.
	 */
	payrollFeedOk(): boolean {
		const st = this.payrollFeedStatus;
		if (!st) { return false; }
		const ready = st.readyAccounts || [];
		if (!st.connected && !ready.length) { return false; }
		if (!this.payrollBankAccounts.length) { return false; }
		const cash = this.payrollCashErpAccounts();
		if (!cash.length) { return ready.length > 0 || st.connected; }
		return this.payrollCashUnreadyAccounts().length === 0;
	}

	payrollFeedWarning(): string {
		const st = this.payrollFeedStatus;
		if (!st) { return ''; }
		if (!this.payrollBankAccounts.length) {
			return 'No bank accounts are set up in the ERP — cash lines will not be offered for bank close-out.';
		}
		if (!st.connected && !(st.readyAccounts || []).length) {
			return 'Bank feed is not configured. Connect SimpleFIN (or drop a statement) under Bank Rec → Connections, or cash close-out will have nothing to match.';
		}
		const missing = this.payrollCashUnreadyAccounts();
		if (missing.length) {
			return `Cash account(s) ${missing.join(', ')} are not mapped to the bank feed. Map them under Bank Rec → Connections, or close-out will not find those withdrawals.`;
		}
		if (!st.connected) {
			return 'SimpleFIN is not connected — close-out can still use previously dropped statement rows, but new pulls will not arrive until it is.';
		}
		return '';
	}

	/** Client-side stand-in when inspect predates feedStatus. */
	private loadPayrollFeedStatusFallback() {
		this.paymentsService.simplefinStatus().subscribe({
			next: (res: any) => {
				if (!res || this.payrollFeedStatus) { return; }
				const map = res.accountMap && !Array.isArray(res.accountMap) ? res.accountMap : {};
				const mapped = Object.keys(map)
					.map(k => (map[k] || '').toString().trim())
					.filter(Boolean);
				this.payrollFeedStatus = {
					connected: !!res.connected,
					mappedAccounts: mapped,
					feedAccounts: [],
					readyAccounts: [...new Set(mapped)],
				};
				if (!this.payrollBankAccounts.length && Array.isArray(res.bankAccounts)) {
					this.payrollBankAccounts = res.bankAccounts;
				}
				this.cdr.detectChanges();
			},
			error: () => { /* card stays hidden — better than a false alarm */ },
		});
	}

	/* ---------- after the journal posts ---------- */

	/**
	 * The cash lines of the journal about to post, one entry per line.
	 *
	 * Per LINE, never aggregated: one payroll run leaves the bank as several
	 * separate withdrawals (net direct deposit, tax collection, 401k), and they only
	 * agree with the journal line by line — the totals never match anything.
	 */
	private collectPayrollCashLines(): any[] {
		return this.debits_credits
			.filter((l: any) => l.payrollIsCash)
			.map((l: any) => ({
				erp_account: l.account?.accountcode || '',
				account_name: l.account?.accountname || '',
				amount: Number(l.debitcredit),
				trandate: this.lineTranYmd(l) || this.todayYmd(),
				hint: l.payrollMatchHint || '',
				source_code: l.payrollSourceCode || '',
				source_desc: l.payrollSourceDesc || '',
				description: l.description || '',
			}));
	}

	private afterPayrollPost(transno: number, cashLines: any[]) {
		const drop = this.payrollPendingDrop;
		this.payrollPendingDrop = null;
		if (!drop) { return; }

		// Log the file FIRST: this row is what stops the same export posting twice,
		// and it has to exist even if the bank step is skipped or fails.
		this.generalLedgerService.payrollImportRecordDrop({ ...drop, transno }).subscribe();

		this.payrollPostedTransno = transno;
		this.payrollBankProfileId = Number(drop.profile_id) || 0;
		this.payrollCashLines = cashLines;
		this.payrollBankLines = [];
		this.payrollBankNotice = '';
		if (cashLines.length) {
			this.loadPayrollBankCandidates(drop.feed_hint || '');
		}
	}

	/** Bank-feed rows that could be each cash line. Read-only — nothing is linked here. */
	loadPayrollBankCandidates(feedHint = '') {
		if (!this.payrollPostedTransno || !this.payrollCashLines.length) { return; }
		this.payrollBankBusy = true;
		this.generalLedgerService.payrollImportBankCandidates({
			transno: this.payrollPostedTransno,
			lines: this.payrollCashLines,
			feed_hint: feedHint || this.payrollFeedHint,
		}).subscribe({
			next: (r: any) => {
				this.payrollBankBusy = false;
				if (!r?.success) {
					this.payrollBankNotice = r?.error || 'Could not read the bank feed.';
					return;
				}
				this.payrollBankLines = (r.lines || []).map((line: any) => {
					const src = this.payrollCashLines[line.index] || {};
					// Pre-select only when there is exactly one candidate. Two lines of
					// the same amount is routine, and picking one for the operator
					// would be a guess wearing a confirmation's clothes.
					const only = line.candidates?.length === 1 ? line.candidates[0] : null;
					return {
						...line,
						accountName: src.account_name || '',
						description: src.description || '',
						sourceCode: src.source_code || '',
						sourceDesc: src.source_desc || '',
						selected: only ? only.sf_id : '',
						// A group is never pre-selected. Several lines adding up to the
						// right number is a coincidence often enough that it has to be
						// a decision, not a default.
						selectedGroup: -1,
						linked: false,
					};
				});
				this.cdr.detectChanges();
			},
			error: () => {
				this.payrollBankBusy = false;
				this.payrollBankNotice = 'Could not reach the bank feed service.';
			},
		});
	}

	/** A candidate already chosen on another line — cannot settle two postings. */
	payrollCandidateTaken(line: any, sfId: string): boolean {
		return this.payrollBankLines.some(o => o !== line && o.selected === sfId);
	}

	payrollSelectedCount(): number {
		return this.payrollBankLines.filter(l => !l.linked && (l.selected || l.selectedGroup >= 0)).length;
	}

	/** The feed rows a line will close: one pick, or every member of a chosen group. */
	private payrollLineMembers(line: any): any[] {
		if (line.selectedGroup >= 0) {
			return line.groups?.[line.selectedGroup]?.members || [];
		}
		if (line.selected) {
			const c = (line.candidates || []).find((x: any) => x.sf_id === line.selected);
			return c ? [c] : [];
		}
		return [];
	}

	/**
	 * Close the confirmed bank lines against the posted journal.
	 *
	 * Writes bank_feed_post_links, the same store the bank-fee journal flow uses —
	 * so the bank lines report as accounted for and drop out of the unreconciled
	 * list, with no banktrans row and no change to the rec engine.
	 */
	linkPayrollBankLines() {
		if (!this.payrollPostedTransno) { return; }
		// One journal line may close several feed rows (a split withdrawal), so this
		// flattens to feed rows — which is what post_links stores, one row each.
		const links = this.payrollBankLines
			.filter(l => !l.linked)
			.flatMap(l => this.payrollLineMembers(l).map((m: any) => ({
				sf_account: m.sf_account || '',
				sf_id: m.sf_id || '',
				description: m.description || '',
				profile_id: this.payrollBankProfileId,
				source_code: l.sourceCode,
				source_desc: l.sourceDesc,
			})))
			.filter(l => l.sf_account && l.sf_id);
		if (!links.length) {
			this.payrollBankNotice = 'Nothing selected to close out.';
			return;
		}
		this.payrollBankBusy = true;
		this.generalLedgerService.payrollImportLinkBank({ transno: this.payrollPostedTransno, links }).subscribe({
			next: (r: any) => {
				this.payrollBankBusy = false;
				const conflicted = new Set((r?.conflicts || []).map((c: any) => c.sf_id));
				this.payrollBankLines.forEach(l => {
					const members = this.payrollLineMembers(l);
					// Only mark a line closed when every row it claimed went through —
					// a half-linked group is not a settled line.
					if (members.length && members.every((m: any) => !conflicted.has(m.sf_id))) {
						l.linked = true;
					}
				});
				this.payrollBankNotice = r?.success
					? `${r.linked} bank line(s) closed against journal #${this.payrollPostedTransno}.`
					: (r?.error || 'Some bank lines could not be closed.');
				this.globalSearchService.showNotification(
					this.payrollBankNotice,
					r?.success ? 'success' : 'warning',
					'bottom',
					'center'
				);
			},
			error: () => {
				this.payrollBankBusy = false;
				this.payrollBankNotice = 'Could not close the bank lines.';
			},
		});
	}

	/**
	 * A reversed journal no longer accounts for anything, so the bank lines it
	 * closed have to go back to unreconciled. Without this they stay marked
	 * "posted as journal #N" against an entry that has been cancelled — they drop
	 * out of the rec silently and nothing ever surfaces them again.
	 *
	 * Runs for every reversal, not just payroll ones: the bank-fee/interest journal
	 * flow writes the same post_links, and reversing one of those has exactly the
	 * same consequence. It also stamps gl_import_drops.reversed_at, which releases
	 * the file hash so a corrected payroll export can be re-posted.
	 */
	private releaseReversedJournalBankLines(transno: number) {
		this.generalLedgerService.payrollImportUnlinkBank({ transno }).subscribe({
			next: (r: any) => {
				if (r?.success && r.removed > 0) {
					this.globalSearchService.showNotification(
						`${r.removed} bank line(s) released back to unreconciled from journal #${transno}.`,
						'info',
						'bottom',
						'center'
					);
				}
			},
			// Silent on failure by design: the reversal itself posted, and a noisy
			// error here would imply it didn't. The banner below covers the risk.
			error: () => {
				this.globalSearchService.showNotification(
					`Journal #${transno} was reversed, but its bank lines could not be released — check the bank rec for lines still showing as posted to it.`,
					'warning',
					'bottom',
					'center'
				);
			},
		});
	}

	dismissPayrollBankPanel() {
		this.payrollPostedTransno = null;
		this.payrollCashLines = [];
		this.payrollBankLines = [];
		this.payrollBankNotice = '';
	}

}
